import { cfpBaseUrl } from './urls';

const MFA_QR_PATH =
  process.env.REACT_APP_MFA_QR_PATH || 'customerFaciliationPortal/mfa/qr';
const MFA_VERIFY_PATH = 'api/auth/verify-mfa';

export function shouldShowMfaStep(loginPayload) {
  const statusCode = String(loginPayload?.status || '');
  const requiresMfaFlag =
    loginPayload?.requiresMfa === true ||
    loginPayload?.isMfaRequired === true ||
    loginPayload?.requiresMFA === true ||
    loginPayload?.requiresQRCode === true;

  // Backend-driven MFA only:
  // - status 206 (MFA required) OR explicit MFA flags.
  // - Normal status 200 without flags will bypass MFA and login directly.
  if (
    statusCode === '206' ||
    requiresMfaFlag
  ) {
    return true;
  }
  return false;
}

export async function fetchMfaQrSetup(token) {
  const headers = new Headers();
  if (token) headers.append('Authorization', token);
  const response = await fetch(cfpBaseUrl + MFA_QR_PATH, {
    method: 'POST',
    headers,
    redirect: 'follow',
  });
  const data = await response.json().catch(() => ({}));
  return { ok: response.ok, data, status: data.status };
}

export async function verifyMfaOtp({ userId, otp, isLoggedInFromMobile = '1' }) {
  const headers = new Headers();
  headers.append('Content-Type', 'application/json');
  const raw = JSON.stringify({
    userId,
    otp,
    isLoggedInFromMobile,
  });
  const response = await fetch(cfpBaseUrl + MFA_VERIFY_PATH, {
    method: 'POST',
    headers,
    body: raw,
    redirect: 'follow',
  });
  const data = await response.json().catch(() => ({}));
  return {
    ok: response.ok,
    data,
    status: data.status || String(response.status),
    message: data.message,
  };
}
